<template>
  <div class="content-list-item-label">
    <el-tooltip :content="label.labelName" placement="top">
      <font-awesome-icon
        class="content-label-icon mr-1"
        :icon="['fad', label.icon]"
        :style="{ '--label-color': label.color }"
      />
    </el-tooltip>
  </div>
</template>

<script>
export default {
  name: 'content-list-item-label',
  props: {
    label: Object,
  },
};
</script>

<style lang="scss" scoped>
.content-label-icon {
  width: 16px;
  height: 16px;
  color: var(--label-color);
  border: 1px solid var(--label-color);
  background-color: rgba(var(--label-color), 0.1);
  border-radius: 2px;
  padding: 2px;
}
</style>